import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const ROLES_REQUEST = 'ROLES_REQUEST';
export const ROLES_SUCCESS = 'ROLES_SUCCESS';
export const ROLES_FAILURE = 'ROLES_FAILURE';

export function requestRoles() {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/roles/all`,
      method: 'GET',
      types: ['ROLES_REQUEST', 'ROLES_SUCCESS', 'ROLES_FAILURE']
    }
  };
}

export function requestRolesTypeahead(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/roles/search?${query}`,
      method: 'GET',
      types: ['ROLES_TYPEAHEAD_REQUEST', 'ROLES_TYPEAHEAD_SUCCESS', 'ROLES_TYPEAHEAD_FAILURE']
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/roles/RolesActions.js